import {NodeType} from 'common/src/modules/nodes/nodes.types';
import iconsObj from '../../assets/icons/iconsObj';

const CAMPAIGN_NODE_ID = 1;
const NO_NODE_ID = 0;
const NEW_OUTPUT_ID = 0;

const NODE_WIDTH = 274;
const CAMPAIGN_NODE_WIDTH = 294;
const CREATIVE_NODE_WIDTH = 253;
const NewNodeXShift = 450;
const NewNodeYShift = 300;

const MinNodeOutputs = 2;

const MaxNameLength = 100;

const CURVATURE_START_OFFSET = 69;
const CREATIVE_INPUT_START_OFFSET = 120;

type NodeConfig = {
  name: string;
  presentationName?: string;
  width: number;
  backgroundColor: string;
  icon: string;
  outputCurveStart: number;
};

const fallBackCreativeConfig: NodeConfig = {
  name: 'Fallback Creative',
  width: CREATIVE_NODE_WIDTH,
  backgroundColor: '#014298',
  outputCurveStart: CREATIVE_INPUT_START_OFFSET,
  icon: iconsObj.decisionTree.fallbackCreative,
};

const nodeTypeConfig: Record<NodeType, NodeConfig> = {
  [NodeType.VIDEO_CAMPAIGN]: {
    name: 'Campaign',
    width: CAMPAIGN_NODE_WIDTH,
    icon: iconsObj.decisionTree.campaign,
    backgroundColor: '#16263d',
    outputCurveStart: 20,
  },
  [NodeType.CAMPAIGN]: {
    name: 'Campaign',
    width: CAMPAIGN_NODE_WIDTH,
    icon: iconsObj.decisionTree.campaign,
    backgroundColor: '#16263d',
    outputCurveStart: 20,
  },
  [NodeType.CONDITION]: {
    name: 'Condition',
    width: NODE_WIDTH,
    icon: iconsObj.decisionTree.condition,
    backgroundColor: '#EB6C00',
    outputCurveStart: CURVATURE_START_OFFSET,
  },
  [NodeType.COMPOUND_CONDITION]: {
    name: 'Compound Condition',
    width: NODE_WIDTH,
    icon: iconsObj.decisionTree.condition,
    backgroundColor: '#EB6C00',
    outputCurveStart: CURVATURE_START_OFFSET,
  },
  [NodeType.WEIGHTED]: {
    name: 'Weighted',
    width: NODE_WIDTH,
    backgroundColor: '#00767B',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.weighted,
  },
  [NodeType.DISTRIBUTION]: {
    name: 'Distribution',
    width: NODE_WIDTH,
    backgroundColor: '#00767B',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.distribution,
  },
  [NodeType.PRODUCTS]: {
    name: 'Product Selection',
    width: NODE_WIDTH,
    backgroundColor: '#B90000',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.products,
  },
  [NodeType.STORE]: {
    name: 'Location Selection',
    width: NODE_WIDTH,
    backgroundColor: '#004CB2',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.store,
  },
  [NodeType.GENERAL_OPTIMIZATION]: {
    name: 'Optimization',
    width: NODE_WIDTH,
    backgroundColor: '#7B005A',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.creative_optimization,
  },
  [NodeType.SCHEDULE]: {
    name: 'Schedule',
    width: NODE_WIDTH,
    backgroundColor: '#25A18E',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.schedule,
  },
  [NodeType.CREATIVE]: {
    name: 'Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.CONCEPT_CREATIVE]: {
    name: 'Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.NATIVE_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Native Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_FACEBOOK_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_TIKTOK_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_YOUTUBE_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_YOUTUBE_DV360_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_SNAPCHAT_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SOCIAL_LINKEDIN_AD_CREATIVE]: {
    name: 'Creative',
    presentationName: 'Social Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.FACEBOOK_CAROUSEL_CREATIVE]: {
    name: 'Carousel',
    presentationName: 'Facebook Carousel Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.FACEBOOK_DPA_CREATIVE]: {
    name: 'Creative',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.FACEBOOK_DPA_CAROUSEL_CREATIVE]: {
    name: 'Carousel',
    width: CREATIVE_NODE_WIDTH,
    backgroundColor: '#2C7BE5',
    outputCurveStart: CREATIVE_INPUT_START_OFFSET,
    icon: iconsObj.decisionTree.creative,
  },
  [NodeType.SEQUENCE]: {
    name: 'Sequence',
    width: NODE_WIDTH,
    backgroundColor: '#55097B',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.sequence,
  },
  [NodeType.CONTENT_FEED]: {
    name: 'Content Selection',
    width: NODE_WIDTH,
    backgroundColor: '#8761F1',
    outputCurveStart: CURVATURE_START_OFFSET,
    icon: iconsObj.decisionTree.contentFeed,
  },
};

const fallbackColor = '#7284A1';

const MIN_SCALE_FOR_DETAILED_NODE = 0.25;
const MAX_SCALE_FOR_BG_ON_ALL_NODE = 0.5;
const NO_DETAILS_SCALE = 0.06;

export {
  MinNodeOutputs,
  MaxNameLength,
  nodeTypeConfig,
  fallBackCreativeConfig,
  fallbackColor,
  NewNodeXShift,
  NewNodeYShift,
  CAMPAIGN_NODE_ID,
  NO_NODE_ID,
  NEW_OUTPUT_ID,
  NodeConfig,
  CREATIVE_NODE_WIDTH,
  MIN_SCALE_FOR_DETAILED_NODE,
  MAX_SCALE_FOR_BG_ON_ALL_NODE,
  NO_DETAILS_SCALE,
};
